import { Box, SxProps } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import SustainabilityContainer from './SustainabilityContainer';
import TextContent from './TextContent';
import GovernanceTab from './GovernanceTab';
import { PIMCORE_CONTENT_BASE_URL } from '../../utils/Pimcore';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { AboutSustainabilityGovernanceContent } from '../../graphql/pimcore/modules/siteContent/types/AboutSustainabilityContent';
import { NEW_CS_BASE_URL as CS_BASE_URL } from '../../utils/ProjectUrls';
import { LinkCollectionEntry } from '../../graphql/pimcore/modules/siteContent/types/SiteContentElement';
import { sanitizeRichText } from '../../graphql/pimcore/modules/siteContent/tools/sanitizeRichText';

interface GovernancePageProps {
    cmsContent: AboutSustainabilityGovernanceContent;
}
export function splitParagraphsFromHtml(html: string): string[] {
    if (typeof window === 'undefined') return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const paragraphs = Array.from(doc.querySelectorAll('p')).map((p) => p.innerHTML.trim());

    return paragraphs;
}

export function resolveLinkHref(
    entry: LinkCollectionEntry | undefined,
    baseUrl: string = PIMCORE_CONTENT_BASE_URL
): string {
    if (!entry) return '';

    if (entry.kind === 'externalLinkFieldCollection' && entry.linkUrl) {
        return entry.linkUrl;
    }

    if (entry.kind === 'internalLinkFieldCollection' && entry.linkRoute) {
        return `${baseUrl}${entry.linkRoute}`;
    }

    return '';
}
const GovernancePage: FunctionComponent<GovernancePageProps> = ({ cmsContent }) => {
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();
    const buttonPropsForSustainabilityCouncil: SxProps = {
        padding: '4px 11px',
        // width: '29rem',
        height: isScreenXs ? '2rem' : '2.75rem',
        backgroundColor: '#E5673E',
        borderRadius: '5px',
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: isScreenSm ? '20px' : isScreenMd ? '18px' : isScreenXs ? '14px' : '24px',
        lineHeight: '36px',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        color: 'white',
        transition: 'none',
        '&:hover': {
            background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
        },
    };
    const buttonPropsForReadMore: SxProps = {
        padding: '4px 11px',
        // width: '29rem',
        height: isScreenXs ? '2rem' : '2.75rem',
        backgroundColor: '#E5673E',
        borderRadius: '5px',
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: isScreenSm ? '20px' : isScreenMd ? '18px' : isScreenXs ? '14px' : '24px',
        lineHeight: '36px',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        color: 'white',
        alignSelf: 'flex-start',
        transition: 'none',
        '&:hover': {
            background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
        },
    };
    // const paragraphs = splitParagraphsFromHtml(cmsContent.additionalText.content);

    const textContent = (
        <>
            <TextContent
                name={'governance'}
                content1={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: sanitizeRichText(
                                cmsContent.additionalText.content,
                                ['ul', 'li', 'a'],
                                ['href', 'target']
                            ),
                        }}
                    />
                }
                content2={''}
                content3={''}
                expandable={true}
                expandButtonSx={buttonPropsForReadMore}
            />
        </>
    );

    return (
        <>
            <ResponsiveSplitSection
                textContent={textContent}
                backgroundColor={'white'}
                smallScreenTextFirst={false}
                imageSrc={cmsContent.mainImage.imageUrl}
                bigScreenAlignItem="flex-start"
                buttonSx={buttonPropsForSustainabilityCouncil}
                buttonText={cmsContent.esgReportLinks.links[0]?.linkText}
                buttonHref={CS_BASE_URL + resolveLinkHref(cmsContent.esgReportLinks.links[0])}
                buttonText2={cmsContent.esgReportLinks.links[1]?.linkText}
                buttonHref2={CS_BASE_URL + resolveLinkHref(cmsContent.esgReportLinks.links[1])}
                buttonText3={cmsContent.links.links[1]?.linkText}
                buttonHref3={resolveLinkHref(cmsContent.links.links[1])}
                buttonText4={cmsContent.links.links[2]?.linkText}
                buttonHref4={resolveLinkHref(cmsContent.links.links[2])}
                buttonText5={cmsContent.links.links[0]?.linkText}
                buttonHref5={resolveLinkHref(cmsContent.links.links[0])}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F8F8F8',
                }}
            >
                <SustainabilityContainer backgroundColor={'#F8F8F8'}>
                    <GovernanceTab cmsContent={cmsContent} />
                </SustainabilityContainer>
            </Box>
        </>
    );
};

export default GovernancePage;
